export const getProviderFromUrl = (baseUrl: string) => {
  const url = baseUrl;

  if (url.includes('fbuat.tteld.com')) return 'fbuat';
  if (url.includes('uat.tteld.com')) return 'uat';
  if (url.includes('btest.tteld.com')) return 'btest';
  if (url.includes('addmin-api.tteld.com')) return 'tteld';
  if (url.includes('addmin-api.evoeld.com')) return 'evoeld';
  if (url.includes('addmin-api.ontime-logs.com')) return 'ontimeeld';
  if (url.includes('addmin-api.zippyeld.com')) return 'zippyeld';
  if (url.includes('front-api.sbaeld.com')) return 'sbaeld';
  if (url.includes('front-api.rtelogs.com')) return 'rtelogs';
  if (url.includes('front-api.rulereld.com')) return 'rulereld';
  if (url.includes('addmin-api.fiveeld.com')) return 'fiveeld';
  if (url.includes('addmin-api.protrux.com')) return 'protrux';
  if (url.includes('addmin-api.rreld.com')) return 'rreld';
  if (url.includes('addmin-api.delta-eld.com')) return 'deltaeld';
  if (url.includes('addmin-api.fleetvision.co')) return 'fleetvision';

  return 'eld';
};
